import { Box } from "@mui/material";
import LanguageContext from "components/LanguageContext";
import PropTypes from "prop-types";
import React, { useCallback, useContext } from "react";
import t from "utils/locales/translation.json";

export const componentClassName = "Da-Button";

const Button = (props) => {
  const {
    outlined,
    external = false,
    fullWidth = false,
    primary,
    iconDSFR = "",
    iconPosition = "right",
    size = "md",
    disabled = false,
    children = null,
    url = "",
    page = null,
    className = "",
    sx = {},
    ...others
  } = props;
  let { kind = "primary", secondaryColor = false } = props;

  if (outlined !== undefined) {
    kind = outlined ? "secondary" : "primary";
  }

  if (primary !== undefined) {
    secondaryColor = !primary;
  }

  const sxStyled = useCallback(
    (theme) => {
      let allSx = sx;
      if (fullWidth) {
        allSx = { ...allSx, width: "100%", justifyContent: "center" };
      }
      if (secondaryColor && !disabled) {
        if (kind === "primary") {
          allSx = {
            ...allSx,
            bgcolor: "secondary.main",
            color: theme.palette.getContrastText(theme.palette.secondary.main),
            "a&:hover, button&:hover": { bgcolor: "secondary.dark" },
          };
        }
        if (kind === "secondary") {
          allSx = {
            ...allSx,
            border: "1px solid",
            borderColor: "secondary.main",
            boxShadow: "none",
            color: "secondary.main",
            "a&:hover, button&:hover": {
              borderColor: "secondary.dark",
              color: "secondary.dark",
            },
          };
        }
        if (["tertiary", "tertiary-no-outline"].includes(kind)) {
          allSx = {
            ...allSx,
            color: "secondary.main",
            "a&:hover, button&:hover": { color: "secondary.dark" },
          };
        }
      }
      return allSx;
    },
    [disabled, fullWidth, kind, secondaryColor, sx],
  );

  const { language } = useContext(LanguageContext);

  const dynamicProps = {
    disabled,
    target: external ? "_blank" : "_self",
    rel: external ? "noopener noreferrer" : undefined,
  };

  let buttonClassName = "fr-btn";
  if (kind && kind !== "primary") {
    buttonClassName += ` fr-btn--${kind}`;
  }
  if (size) {
    buttonClassName += ` fr-btn--${size}`;
  }
  if (!external && iconPosition && iconDSFR) {
    buttonClassName += ` fr-btn--icon-${iconPosition} fr-icon-${iconDSFR}`;
  }
  if (className) {
    buttonClassName += ` ${className}`;
  }

  return (
    <Box
      component="button"
      className={buttonClassName}
      sx={(theme) => sxStyled(theme)}
      url={url}
      page={page}
      aria-hidden={disabled}
      aria-label={
        typeof children === "string" && children !== ""
          ? children
          : `${t[language].components.link_to} ${url || page?.title}`
      }
      {...dynamicProps}
      {...others}
    >
      {children}
    </Box>
  );
};
Button.propTypes = {
  external: PropTypes.bool,
  outlined: PropTypes.bool,
  kind: PropTypes.string,
  fullWidth: PropTypes.bool,
  primary: PropTypes.bool,
  secondaryColor: PropTypes.bool,
  iconDSFR: PropTypes.string,
  iconPosition: PropTypes.string,
  size: PropTypes.string,
  disabled: PropTypes.bool,
  children: PropTypes.node,
  url: PropTypes.string,
  page: PropTypes.oneOfType([PropTypes.shape(), PropTypes.node]),
  className: PropTypes.string,
  sx: PropTypes.shape(),
};

export default Button;
